"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamMemberOption = getTeamMemberOption;
exports.userAuthType = exports.teamMemberRoleOptions = exports.teamMemberRoles = exports.teamMemberValues = exports.userStatusBadges = exports.userStatusOptions = exports.userStatusLabels = exports.userStatus = exports.userRoleOptions = exports.userRoleLabels = exports.userRole = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _userRoleLabels, _userStatusLabels, _userStatusBadges;

var userRole = {
  EMPLOYEE: 'employee',
  EMPLOYER: 'employer',
  DELETED: 'deleted',
  ADMIN: 'admin',
  SERVICE_PROVIDER: 'service_provider'
};
exports.userRole = userRole;
var userRoleLabels = (_userRoleLabels = {}, (0, _defineProperty2["default"])(_userRoleLabels, userRole.EMPLOYEE, 'Employee'), (0, _defineProperty2["default"])(_userRoleLabels, userRole.EMPLOYER, 'Employer'), (0, _defineProperty2["default"])(_userRoleLabels, userRole.DELETED, 'Deleted'), (0, _defineProperty2["default"])(_userRoleLabels, userRole.ADMIN, 'Admin'), (0, _defineProperty2["default"])(_userRoleLabels, userRole.SERVICE_PROVIDER, 'Service provider'), _userRoleLabels);
exports.userRoleLabels = userRoleLabels;
var userRoleOptions = Object.keys(userRoleLabels).map(function (value) {
  return {
    value: value,
    label: userRoleLabels[value]
  };
});
exports.userRoleOptions = userRoleOptions;
var userStatus = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  CREATED: 'created',
  DELETED: 'deleted',
  INITIATED: 'initiated'
};
exports.userStatus = userStatus;
var userStatusLabels = (_userStatusLabels = {}, (0, _defineProperty2["default"])(_userStatusLabels, userStatus.ACTIVE, 'Active'), (0, _defineProperty2["default"])(_userStatusLabels, userStatus.CANCELLED, 'Canceled'), (0, _defineProperty2["default"])(_userStatusLabels, userStatus.CREATED, 'Created'), (0, _defineProperty2["default"])(_userStatusLabels, userStatus.DELETED, 'Deleted'), (0, _defineProperty2["default"])(_userStatusLabels, userStatus.INITIATED, 'Initiated'), _userStatusLabels);
exports.userStatusLabels = userStatusLabels;
var userStatusOptions = Object.entries(userStatusLabels).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];

  return {
    value: value,
    label: label
  };
});
exports.userStatusOptions = userStatusOptions;
var userStatusBadges = (_userStatusBadges = {}, (0, _defineProperty2["default"])(_userStatusBadges, userStatus.ACTIVE, 'active'), (0, _defineProperty2["default"])(_userStatusBadges, userStatus.CANCELLED, 'inactive'), (0, _defineProperty2["default"])(_userStatusBadges, userStatus.CREATED, 'pending'), (0, _defineProperty2["default"])(_userStatusBadges, userStatus.DELETED, 'inactive'), (0, _defineProperty2["default"])(_userStatusBadges, userStatus.INITIATED, 'pending'), _userStatusBadges);
exports.userStatusBadges = userStatusBadges;
var teamMemberValues = {
  VIEWER: 'viewer',
  ADMIN: 'admin',
  OWNER: 'owner'
};
exports.teamMemberValues = teamMemberValues;
var teamMemberLabels = {
  VIEWER: 'Viewer',
  ADMIN: 'Admin',
  OWNER: 'Owner'
};
var teamMemberRoles = [{
  label: teamMemberLabels.VIEWER,
  value: teamMemberValues.VIEWER
}, {
  label: teamMemberLabels.ADMIN,
  value: teamMemberValues.ADMIN
}, {
  label: teamMemberLabels.OWNER,
  value: teamMemberValues.OWNER
}];
/**
 * We should not show the owner type when inviting a new team member
 */

exports.teamMemberRoles = teamMemberRoles;
var teamMemberRoleOptions = teamMemberRoles.filter(function (teamMember) {
  return teamMember.value !== teamMemberValues.OWNER;
});
exports.teamMemberRoleOptions = teamMemberRoleOptions;

function getTeamMemberOption(value) {
  return teamMemberRoles.find(function (teamMemberOption) {
    return teamMemberOption.value === value;
  });
}

var userAuthType = {
  HIRE_CONTRACTORS: 'hire_contractors',
  HIRE_EMPLOYEES: 'hire_employees',
  HIRE_BOTH: 'hire_both'
};
exports.userAuthType = userAuthType;